import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addShowingStatus, getShowingStatus, updateShowingStatus, deleteShowingStatus} from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import SafeField from "helpers/SafeField";

class ShowingStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showingstatus: ''
        }
        this.handleShowingStatusSubmit = this.handleShowingStatusSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (showingstatus) => {
        this.setState({ showingstatus: showingstatus });
        this.setState({ deleteModal: true });
    };

    handleDeleteShowingStatus = () => {
        const { onDeleteShowingStatus} = this.props;
        const { showingstatus } = this.state;

        if (showingstatus.id !== undefined) {
            onDeleteShowingStatus(showingstatus);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleShowingStatusSubmit(value) {
        this.props.addShowingStatus(value, this.props.history);
    }

    componentDidMount() {
        const { onGetShowingStatus } = this.props;
        onGetShowingStatus(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { showingstatuses } = this.props;
        if (!isEmpty(showingstatuses) && size(prevProps.showingstatuses) !== size(showingstatuses)) {
            this.setState({ showingstatuses: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ showingstatus: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const showingstatus = arg;
        this.setState({
            showingstatus: {
                id: showingstatus.id,
                showingStatusId: showingstatus.showingStatusId,
                showingStatusTitle: showingstatus.showingStatusTitle,
                agentId: showingstatus.agentId,
                isActive:showingstatus.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { showingstatuses, onUpdateShowingStatus } = this.props;
        const { isEdit, deleteModal } = this.state;
        const showingstatus = this.state.showingstatus;
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteShowingStatus}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Showing Status | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Showing Status")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        showingStatusTitle: (this.state && this.state.showingStatusTitle) || "",
                                        agentId: parseInt(localStorage.getItem('userId'))
                                    }}
                                    validationSchema={Yup.object().shape({
                                        showingStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleShowingStatusSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="showingStatusTitle">
                                                                    {this.props.t("Title")}
                                                                </Label>
                                                                <SafeField
                                                                    name="showingStatusTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.showingStatusTitle && touched.showingStatusTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="showingStatusTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="showingStatusTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">Showing Status History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(showingstatuses, (showingstatus, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{showingstatus.showingStatusTitle}</td>
                                                                        <td>
                                                                            <UncontrolledDropdown direction="up">
                                                                                <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                                                                    Action <i className="mdi mdi-chevron-down"></i>
                                                                                </DropdownToggle>
                                                                                <DropdownMenu>
                                                                                    <DropdownItem onClick={() => this.toggleRightCanvas(showingstatus)} href="#">Edit</DropdownItem>
                                                                                    <DropdownItem onClick={() => this.onClickDelete(showingstatus)} href="#">Delete</DropdownItem>


                                                                                </DropdownMenu>
                                                                            </UncontrolledDropdown>

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: showingstatus.id,
                                        showingStatusId: showingstatus.showingStatusId,
                                        showingStatusTitle: showingstatus.showingStatusTitle,
                                        agentId: showingstatus.agentId,
                                        isActive:showingstatus.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        showingStatusTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                showingStatusId: values.showingStatusId,
                                                showingStatusTitle: values.showingStatusTitle,
                                                agentId: values.agentId,
                                                isActive:values.isActive
                                            };
                                            onUpdateShowingStatus(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="showingStatusTitle">
                                                            {this.props.t("Title")}
                                                        </Label>
                                                        <SafeField
                                                            name="showingStatusTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.showingStatusTitle && touched.showingStatusTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="showingStatusTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="showingStatusTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ShowingStatus.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addShowingStatus : PropTypes.func,
    onGetShowingStatus: PropTypes.func,
    showingstatuses: PropTypes.array,
    onDeleteShowingStatus: PropTypes.func,
    onUpdateShowingStatus: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        showingstatuses: AppoinmentObject.showingstatuses,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addShowingStatus: (data) => dispatch(addShowingStatus(data)),
    onGetShowingStatus: (agentId) => dispatch(getShowingStatus(agentId)),
    onDeleteShowingStatus: (id) => dispatch(deleteShowingStatus(id)),
    onUpdateShowingStatus: (data) => dispatch(updateShowingStatus(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShowingStatus))
